
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/learning",
      function () {
        return require("private-next-pages/cases/learning.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cases/learning"])
      });
    }
  